/**
* Service Slider Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Slider Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-slider-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.service-slider__slider' ).length ) {
        $( '.service-slider__slider' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            focus: 'center',
            gap: '20px',
            arrows: true,
            pagination: false,
            breakpoints: {
              640: {
                perPage: 1,
              },
              768: {
                perPage: 2,
              },
              1024: {
                perPage: 3,
              },
            },
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-slider-hero', COMPONENT );
} )( app );
